import type { IconWrapperProps } from "./icon-wrapper";
import { IconWrapper } from "./icon-wrapper";

interface BergamontBrandIconProps extends IconWrapperProps {
  variant?: "light" | "dark";
}

function BergamontBrandSvg(props: {
  variant?: "light" | "dark";
  className?: string;
}) {
  const variant = props.variant || "light";
  const fillColor = variant === "light" ? "currentColor" : "#44403C";

  return (
    <svg
      className={props.className}
      fill="none"
      role="img"
      viewBox="0 0 48 48"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>Bergamont</title>
      <path
        d="M20.2061 16.3771L24.6464 8.64578C24.8078 8.36128 24.6167 8 24.3068 8H15.7021C15.354 8 15.0271 8.19419 14.8446 8.5103L6.14645 23.6568C5.95118 24 5.95118 24.429 6.14645 24.7677L14.5984 39.4897C14.7809 39.8058 15.1035 40 15.4559 40H32.0923C32.4404 40 32.7673 39.8058 32.9498 39.4897L41.9281 23.851C42.0979 23.5574 41.9536 23.1691 41.6352 23.0833L20.4948 17.1448C20.1806 17.0545 20.0321 16.6706 20.2019 16.3726M12.1278 30.4443L14.9804 25.4767C15.1587 25.1696 15.5068 25.0206 15.8337 25.1109L35.7388 30.7017C35.9171 30.7513 35.8831 31.0313 35.7006 31.0313H12.4376C12.1532 31.0313 11.9792 30.7017 12.1278 30.4443Z"
        fill={fillColor}
      />
    </svg>
  );
}

export function IconBergamontBrand(props: BergamontBrandIconProps) {
  return (
    <IconWrapper {...props}>
      <BergamontBrandSvg className={props.className} variant={props.variant} />
    </IconWrapper>
  );
}
